import React from 'react';
import { SettingsWrapper } from '../styles';
import Heading from '~ComponentsImproved/Typography/Heading';
import { PageNames } from '../Context/PageProvider';

type Props = {
  children?: React.ReactNode;
  backTo?: {
    title: string;
    key: PageNames;
  };
  pageTitle?: string;
};

const HandyPageWrapper = ({ children, pageTitle }: Props) => {
  return (
    <SettingsWrapper>
      {pageTitle && (
        <Heading level={2} color="var(--colorWhite)">
          {pageTitle}
        </Heading>
      )}
      {children}
    </SettingsWrapper>
  );
};

export default HandyPageWrapper;
